module.exports = __webpack_public_path__ + "static/media/Abhijeeth.42f9b2d9.jpg";